<template>
  <v-container
    id="reportExport-view"
    fluid
    tag="section"
  >
    <material-card
      icon="$reports"
      icon-small
      color="accent"
      :title="page_title"
    >
      <template v-slot:title2>
        <div class="text-h5">
          <tooltip-btn
            icon="$back"
            tooltip="components"
            @click="back"
          />
        </div>
      </template>
      <v-card
        v-if="params.length > 0"
        class="mx-3 pa-3"
      >
        Paraméterek:
        <v-row>
          <v-col
            v-for="(param, i) in params"
            :key="i"
            cols="12"
            md="4"
          >
            <data-selector
              v-if="param.type == 'list'"
              v-model="param.value"
              :field-name="param.label"
              :source-type="param.source_type"
              hide-details
            />
            <v-text-field
              v-else-if="param.type == 'int'"
              v-model="param.value"
              :label="param.label"
            />
            <date-field
              v-else-if="param.type == 'date'"
              v-model="param.value"
              :field-name="param.label"
            />
          </v-col>
        </v-row>
      </v-card>
      <v-card-title>
        <export-btn
          v-if="items.length != 0"
          source-type="report"
          :params="{ report_id: report.id, params: params}"
        />
        <v-row class="ma-0">
          <v-spacer v-if="!$vuetify.breakpoint.mdAndDown" />
          <v-text-field
            v-model="search"
            append-icon="$search"
            class="ml-auto"
            hide-details
            :label="$t('search_records')"
            single-line
          />
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          :loading-text="$t('loading')"
          :search="search"
          :footer-props="footerProps"
          :custom-sort="customSort"
        />
      </v-card-text>
    </material-card>
  </v-container>
</template>

<script>
  // Utilities
  import { get, call, sync } from 'vuex-pathify'
  import { startOfYear, format } from 'date-fns'

  export default {
    name: 'ReportExport',
    data () {
      return {
        items: [],
        params: [],
        formats: [],
        footerProps: {
          itemsPerPageOptions: [10, 20, 25, 50, 100],
        },
        headers: [],
        report: null,
        total: 0,
        timer: null,
        report_name: '',
      }
    },
    computed: {
      loading: get('app/loading'),
      profile: get('auth/profile'),
      options: sync('report/options'),
      search: sync('report/search'),
      prevRoute: sync('report/prevRoute'),
      actions () {
        return [
          // { color: 'info', icon: '$info' },
          { color: 'export', icon: '$export', tooltip: 'tooltip_export', func: this.export, disable: !this.editor },
          { color: 'edit', icon: '$edit', tooltip: 'tooltip_edit', func: this.edit, disable: !this.editor },
        ]
      },
      page_title () { return this.$t('reports') + ' - ' + this.report_name },
      editor () { return true },
    },
    watch: {
      params: {
        handler () {
          if (this.timer) {
            clearTimeout(this.timer)
            this.timer = null
          }
          this.timer = setTimeout(() => {
            this.load()
          }, 800)
        },
        deep: true,
      },
    },
    mounted () {
      this.fetch()
    },
    methods: {
      getList: call('report/export'),
      fetchEditedItem: call('report/fetch'),
      async load () {
        const reportId = parseInt(this.$route.params.id)
        this.headers = []
        this.items = []
        try {
          await this.getList({
            report_id: reportId,
            params: this.params,
          }).then(response => {
            if (response != null) {
              this.headers = Object.keys(response[0]).map((item, index) => ({ value: item, text: this.report.translation ? this.$t('rpt.' + item) : item, sortable: true }))
              this.items = response
            }
          }).catch(e => {
            // console.log(e)
          })
        } catch (e) {
        }
      },
      async fetch () {
        const reportId = parseInt(this.$route.params.id)
        // this.loading = true
        if (!this.new_item) {
          this.fetchEditedItem({ id: reportId }).then(response => {
            this.report = response
            this.report_name = this.report.name

            this.params = JSON.parse(this.report.params)
            this.formats = JSON.parse(this.report.formats)

            if (this.params.filter(p => p.name === 'start').length > 0) {
              // this.params.filter(p => p.name === 'start')[0].value = format(startOfYear(new Date()), 'yyyy-MM-dd')
              this.$set(this.params.filter(p => p.name === 'start')[0], 'value', format(startOfYear(new Date()), 'yyyy-MM-dd'))
            }
            if (this.params.filter(p => p.name === 'end').length > 0) {
              // this.params.filter(p => p.name === 'end')[0].value = format(new Date(), 'yyyy-MM-dd')
              this.$set(this.params.filter(p => p.name === 'end')[0], 'value', format(new Date(), 'yyyy-MM-dd'))
            }
            if (this.params.filter(p => p.name === 'year').length > 0) {
              this.$set(this.params.filter(p => p.name === 'year')[0], 'value', parseInt(format(new Date(), 'yyyy')))
            }
            // this.load()
            // this.loading = false
          })
        }
      },
      edit (id) {
        this.$router.push(`/report/${id}`).catch(() => {})
      },
      export (id) {
        this.$router.push(`/report/export/${id}`).catch(() => {})
      },
      customSort (items, index, isDesc) {
        let isNumber = false
        const idx = this.headers.map((item) => item.value).indexOf(index[0])
        if (this.formats.length > 0 && idx > -1) {
          if (this.formats.filter(p => p.idx === idx).length > 0) {
            isNumber = this.formats.filter(p => p.idx === idx)[0].type === 'num'
          }
        }
        /* if (this.formats.filter(p => p.idx === 2).length > 0) {
          console.log(this.formats.filter(p => p.idx === idx)[0])
        } */
        items.sort((a, b) => {
          if (index[0] === 'flight_time') {
            // console.log('time')
            const minA = parseInt(a[index].split(':')[0] * 60 + a[index].split(':')[1])
            const minB = parseInt(b[index].split(':')[0] * 60 + b[index].split(':')[1])
            if (!isDesc[0]) {
              return minA < minB ? -1 : 1
            } else {
              return minB < minA ? -1 : 1
            }
          } else if (isNumber) {
            // console.log('numerikus')
            if (!isDesc[0]) {
              return parseInt(a[index]) < parseInt(b[index]) ? -1 : 1
            } else {
              return parseInt(b[index]) < parseInt(a[index]) ? -1 : 1
            }
          } else {
            // console.log('nem numerikus')
            if (!isDesc[0]) {
              return a[index] < b[index] ? -1 : 1
            } else {
              return b[index] < a[index] ? -1 : 1
            }
          }
        })
        return items
      },
      back () {
        // console.log('this prevRoute' + this.prevRoute)
        this.$router.push(this.prevRoute).catch(() => {})
      },
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.prevRoute = from
      })
    },
  }
</script>
